import Component from '../core/Component'
import PositionObserver from '../meta/PositionObserver'
import anime from 'animejs'

export default class DecorM extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            paths: []
        }

        this.ref.paths = this.element.querySelectorAll('path')
    }

    prepare() {
        this.observer = new PositionObserver(this.element, {
            onEnter: this.handleEnter
        })
    }

    destroy() {
        this.detach()
    }

    render() {
        this.animation = anime({
            targets: this.ref.paths,
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: 'easeInOutSine',
            duration: 1300,
            delay: function (el, i) { return 500 + i * 250 },
            autoplay: true
        })
    }
    
    
    handleEnter = () => {
        this.render()
        this.detach()
    }

    detach() {
        if (this.observer) {
            this.observer.destroy()
            this.observer = null
        }
    }
}